import { render } from "./ComMinusButton.vue?vue&type=template&id=0e1b9b07&ts=true"
import script from "./ComMinusButton.vue?vue&type=script&lang=ts"
export * from "./ComMinusButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__